<div id="main-container" class="page-container" [class.has-promo-line]="$hasPromoLine()" [class.has-header]="!(isExternalPage$ | async)">
  @if($hasPromoLine()) {
    <app-promo-line
      [promo]="app.$promocode()"
      [showCopyCheck]="$showCopyCheck()"
      (openPricing)="openPricing()"
      (copyCode)="copyToClipboard(app.$promocode()?.code)"
      (closePromo)="closePromocodeLine()">
    </app-promo-line>
  }
  <app-header *ngIf="!(isExternalPage$ | async)" [hasPromoLine]="$hasPromoLine()"></app-header>
  <router-outlet></router-outlet>
  <app-footer *ngIf="!(isExternalPage$ | async) && !$hideFooter()" class="widget" #footerRef></app-footer>
  <app-to-top-button *ngIf="!(isExternalPage$ | async) && !(hideToTopButton$ | async)"
    [class.on-dark]="$toTopBtnBackground() === 'dark'"></app-to-top-button>
  <app-toaster></app-toaster>
</div>
<app-modal></app-modal>
